import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    appbar: {
        height: '5rem',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginBottom: '1rem'
    },
    div: {
        display: 'flex',
    }

})

export default useStyles